import { configureStore } from '@reduxjs/toolkit';
import hotelsReducer from '../features/hotels/hotelsSlice';
import templesReducer from '../features/temples/templesSlice';
import routesReducer from '../features/routes/routesSlice';
import plannerReducer from '../features/planner/plannerSlice';

export const store = configureStore({
  reducer: {
    hotels: hotelsReducer,
    temples: templesReducer,
    routes: routesReducer,
    planner: plannerReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export default store;
